import React, { useState } from "react";
import dayjs from "dayjs";
import { LineBoxContainer } from "../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../components/Button/CalendarLineBtn";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import LineBtn from "../../components/Button/LineBtn";
import Flex from "../../components/DefaultStyles/Flex";
import CalendarModal from "../../components/Modal/CalendarModal";
import { CalendarLine } from "../../components/pages/Party/ChatInfo/ChatSearch/RecentChat";

interface NewUserLogDateFilterProps {
  filter: {
    startDate: string;
    endDate: string;
  };
  setFilter: any;

  isAfter?: {
    value: number;
    unit: string;
  };
}

export default function NewUserLogDateFilter({
  filter,
  setFilter,

  isAfter,
}: NewUserLogDateFilterProps) {
  const [startDate, setStartDate] = useState(
    filter?.startDate !== "" ? filter?.startDate : ""
  );
  const [startDateClick, setStartDateClick] = useState(false);

  const [endDate, setEndDate] = useState(
    filter?.endDate !== "" ? filter?.endDate : ""
  );
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <Flex gapSize={10}>
      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setStartDateClick(true)}
          value={startDate}
          initValue={"날짜 선택"}
        />

        {startDateClick && (
          <CalendarModal
            closeEvent={() => setStartDateClick(false)}
            changeEvent={(date: string) => setStartDate(date)}
            sPosition="absolute"
            // isFutureDisableFromToday={true}
            isFutureDisable={true}
            isTodayDisable={false}
          />
        )}
      </LineBoxContainer>

      <CalendarLine />

      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setEndDateClick(true)}
          value={endDate}
          initValue={"날짜 선택"}
          disabled={startDate === "날짜 선택"}
        />

        {endDateClick && (
          <CalendarModal
            closeEvent={() => setEndDateClick(false)}
            changeEvent={(date: string) => setEndDate(date)}
            sPosition="absolute"
            dateValue={startDate}
            isTodayDisable={false}
            isAfter={isAfter}
          />
        )}
      </LineBoxContainer>

      <ConfirmBtn
        btnColor="mint"
        btnText="적용"
        btnHeight={38}
        isDisabled={startDate === "날짜 선택" || endDate === "날짜 선택"}
        btnClickEvent={() => {
          setFilter({
            ...filter,
            startDate: dayjs(startDate)?.format("YYYY-MM-DD"),
            endDate: dayjs(endDate)?.format("YYYY-MM-DD"),
          });
        }}
      />

      <LineBtn
        btnColor="mint"
        btnText="초기화"
        icon="refresh"
        btnHeight={38}
        disabled={startDate === "날짜 선택" && endDate === "날짜 선택"}
        btnClickEvent={() => {
          setFilter({
            ...filter,
            startDate: dayjs().add(0, "day")?.format("YYYY-MM-DD"),
            endDate: dayjs().add(0, "day")?.format("YYYY-MM-DD"),
          });
          setStartDate(dayjs().add(0, "day")?.format("YYYY-MM-DD"));
          setEndDate(dayjs().add(0, "day")?.format("YYYY-MM-DD"));
        }}
      />
    </Flex>
  );
}
